export default __webpack_public_path__ + "static/media/pack-super-rare.c71760e9.png";